// Keep in sync with app/lib/enums/client_manufacturer_product_enum.py

const ClientManufacturerProductStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
});

export { ClientManufacturerProductStatus };
